import { UserType } from 'models';

import { UserInvitationProps } from 'services/UserService';

const UserHelpers = {
    swr: {
        userInvitations: (props: UserInvitationProps) => `/userInvitations?query=${JSON.stringify(props)}`,
    },

    localStorageKey: {
        referrer: 'userReferrer',
        type: 'userType',
        email: 'userEmail',
        name: 'userName',
        event: 'userEventWithExpiry',
        userId: 'userId',
    },

    isUserType: (value: unknown): value is UserType => Object.values(UserType).includes(value as UserType),
};

export { UserHelpers };
